import React from 'react';

const BodyContext = React.createContext({
  setActiveLink: () => {},
});

export default BodyContext;
